module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0153.jpg?v=a379f1ad";